var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcheckgreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 10.1136L13.1281 3.98535L14.0709 4.92816L6.99984 11.9992L2.7572 7.7566L3.70002 6.81381L6.99984 10.1136Z",
    fill: "#18CC3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcheckgreen);
export default __webpack_public_path__ + "static/media/icon.check.green.1aba4ca89746d98ce2ee6489a725401c.svg";
export { ForwardRef as ReactComponent };